import { CdkDrag, CdkDragDrop, CdkDragHandle, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { NgFor, NgIf } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import { FormsModule, UntypedFormControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { get } from 'lodash';

export interface StringListAddEditModel {
	Id: number;
	StringValue?: string;
}

@Component({
    selector: 'string-list-add-edit',
    templateUrl: './string-list-add-edit.component.html',
    styleUrls: ['./string-list-add-edit.component.less'],
    standalone: true,
    imports: [
        NgIf,
        MatButtonModule,
        MatTooltipModule,
        MatIconModule,
        CdkDropList,
        NgFor,
        CdkDrag,
        FormsModule,
        CdkDragHandle,
    ],
})
export class StringListAddEditComponent implements OnChanges {
	@Input() values: string[];
	@Input() disabled: boolean;
	@Input() control: UntypedFormControl;
	@Output() changeEmitter = new EventEmitter<string[]>();
	@ViewChildren('stringInput') inputs: QueryList<ElementRef>;

	data = [];
	tempId = 0;

	get cleanedResults(): string[] {
		return this.data.filter((f: StringListAddEditModel) => f.StringValue?.trim()?.length > 0).map((m) => m.StringValue?.trim());
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (get(changes, 'values.currentValue', null) !== null && get(changes, 'values.firstChange', false)) {
			this.data = this.values.map((m) => {
				this.tempId++;
				return { Id: this.tempId, StringValue: m } as StringListAddEditModel;
			});
			this.control.setValue(this.cleanedResults);
		}

		if (get(changes, 'disabled.currentValue', false) && this.data.length > 0) {
			setTimeout(() => {
				this.data = [];
				this.emitChanges();
			}, 100);
		}
	}

	onInputChange(): void {
		this.emitChanges();
	}

	drop(event: CdkDragDrop<string[]>) {
		if (event.previousContainer === event.container) {
			moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
		}
		this.emitChanges();
	}

	add(): void {
		const idNum = this.data?.length + 1 || 1;
		this.data.push({ Id: idNum });
		setTimeout(() => {
			const inputRef = get(this.inputs, 'last', null);
			inputRef.nativeElement.focus();
		}, 100);
	}

	remove(item: StringListAddEditModel): void {
		this.data = this.data.filter((f) => f.Id !== item.Id);
		this.emitChanges();
	}

	emitChanges(): void {
		this.values = this.cleanedResults;
		this.control.setValue(this.cleanedResults);
		this.changeEmitter.emit(this.values);
	}
}
